import React from 'react';
import { Space } from '@cashfree-intl/coherent';
import CashfreeFullLogo from 'components/CustomIcons/CashfreeFullLogo';
import { setItemsInLocalStorage } from 'utils/common';
import { basename } from 'store';
import { useSearchParams } from 'react-router-dom';
import {
  HeaderContainer,
  LogoWrapper,
} from 'containers/CheckoutJourney/styled';

const Header = () => {
  const [searchParams] = useSearchParams();

  const onLogoClick = () => {
    setItemsInLocalStorage({ checkoutJourneySkipped: true });
    window.location.href = `${basename}landing${
      searchParams.get('env') ? `?env=${searchParams.get('env')}` : ''
    }`;
  };

  return (
    <HeaderContainer>
      <Space fullWidth alignItems="flex-start" justifyContent="space-between">
        <LogoWrapper onClick={onLogoClick}>
          <CashfreeFullLogo />
        </LogoWrapper>
      </Space>
    </HeaderContainer>
  );
};

export default Header;
